import { styled, Grid as MuiGrid } from "@mui/material";
import {
  supernova,
  white,
  crusta,
  baliHai
} from "../../../../assets/styles/colors";

const PREFIX = "PlanNewActionsStyles";
export const classes = {
  cancelButton: `${PREFIX}-cancelButton`,
  saveButton: `${PREFIX}-saveButton`,
  markedButton: `${PREFIX}-markedButton`,
  addPlanButton: `${PREFIX}-addPlanButton`
};

export const Grid = styled(MuiGrid)(() => ({
  [`& .${classes.cancelButton}`]: {
    color: crusta
  },
  [`& .${classes.saveButton}`]: {
    color: white
  },
  [`& .${classes.markedButton}`]: {
    backgroundColor: supernova
  },
  [`& .${classes.addPlanButton}`]: {
    backgroundColor: baliHai
  }
}));
